module.exports = __webpack_public_path__ + "img/CXQAUSLogo - Dark.97fee606.png";